
import React, { useState, useEffect } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import IntegrationsPanel from "@/components/integrations/IntegrationsPanel";
import CommunicationChannels from "@/components/integrations/CommunicationChannels";
import { Plug, MessageSquare } from "lucide-react";
import PageHeader from "@/components/common/PageHeader";
import { useLocation } from "react-router-dom";

const IntegrationsPage = () => {
  const location = useLocation();
  const locationState = location.state as { defaultTab?: string } | null;
  const [activeTab, setActiveTab] = useState(locationState?.defaultTab || "business");

  // Update active tab if location state changes
  useEffect(() => {
    if (locationState?.defaultTab) {
      setActiveTab(locationState.defaultTab);
    }
  }, [locationState]);

  return (
    <div className="space-y-6">
      <PageHeader 
        title="Integrations" 
        description="Connect your VirtuStaff to external services and communication platforms"
      />
      
      <Tabs 
        defaultValue={activeTab} 
        value={activeTab} 
        onValueChange={setActiveTab}
        className="w-full"
      >
        <TabsList className="mb-6 grid grid-cols-2 max-w-md">
          <TabsTrigger value="business" className="flex items-center gap-2">
            <Plug className="h-4 w-4" />
            <span>Business Tools</span>
          </TabsTrigger>
          <TabsTrigger value="communication" className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4" />
            <span>Communication</span>
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="business" className="mt-6">
          <IntegrationsPanel />
        </TabsContent>
        
        <TabsContent value="communication" className="mt-6">
          <CommunicationChannels />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default IntegrationsPage;
